import {useUserContext} from "../../contexts/user-context";
import {Autocomplete, TextField} from "@mui/material";
import React, { useCallback } from "react";
import {Select} from "./Select";
import {SelectId} from "./SelectId";

export function CampaignShortcutSelect(props) {
    const userContext = useUserContext();
    const options  = userContext.user.campaignShortcuts.slice().reverse();

    /*let selected = {id: '', label: 'None'};
    if(props.value) {
        options.forEach((v) => {
            if(v.id==props.value) {
                selected = v;
            }
        });
    }*/
    const renderOptionString = useCallback((option:any)=>{
        if(!option||!option?.job_reference) return '';
        return '['+option?.job_reference+'] '+option?.name;
    },[]);
    if(!Array.isArray(options)) {
        return <div>ERROR</div>;
    }

    return (!props.valueIsId)?<Select {...props} value={props.value} renderOptionString={renderOptionString}/>:
    <SelectId {...props} value={props.value} options={options} renderOptionString={renderOptionString}/>
/*    return (<Autocomplete fullWidth={props.fill} options={options}
                          label={props.label}
                          noOptionsText="No results."
                          getOptionLabel={(option:any)=>('['+option?.job_reference+'] '+option?.name)}
                          value={selected}
                          onChange={props.onChange}
                          renderInput={(params)=><TextField {...params} />}
        />
    );*/
}
